import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  topbarAvatar: {
    height: '2rem',
    width: '2rem',
    fontSize: '0.875rem',
    fontWeight: 700,
    color: 'white',
    cursor: 'pointer'
  },
  accountHeader: {
    padding: 0,
    a: {
      padding: '1rem'
    },
    '.MuiAvatar-root': {
      width: '1.75rem',
      height: '1.75rem',
      marginLeft: '-0.25rem'
    }
  },
  userAccountMenu: {
    '.MuiList-root': {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
}));

export default useStyles;
